import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c32e165e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-csv-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Upload .CSV file", -1))
const _hoisted_3 = { class: "uploader-container" }
const _hoisted_4 = { class: "uploader" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Upload file with keywords", -1))
const _hoisted_6 = {
  key: 0,
  for: "csv"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_language_selector = _resolveComponent("language-selector")!
  const _component_loading_icon = _resolveComponent("loading-icon")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_language_selector, {
        value: _ctx.selectedLanguage,
        class: "language",
        onUpdate: _ctx.setLanguage
      }, null, 8, ["value", "onUpdate"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("label", _hoisted_6, "Upload .CSV"))
          : (_openBlock(), _createBlock(_component_loading_icon, {
              key: 1,
              class: "loader-icon"
            })),
        _createElementVNode("input", {
          type: "file",
          id: "csv",
          accept: ".csv, text/csv",
          style: {"display":"none"},
          ref: "file",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
          capture: "",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetInputValue && _ctx.resetInputValue(...args)))
        }, null, 544)
      ])
    ])
  ]))
}